import { Link } from "react-router-dom";
import { FinancingCalculator } from "@/components/FinancingCalculator";

export const FinancingSection = ({ content }) => {
  return (
    <section className="py-16 bg-muted border-y border-border" data-testid="financing-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`grid grid-cols-1 ${content.show_calculator ? "lg:grid-cols-2" : ""} gap-12 items-center`}>
          <div>
            {content.eyebrow && (
              <p className="text-xs font-mono uppercase tracking-[0.25em] text-primary mb-2">{content.eyebrow}</p>
            )}
            <h2 className="font-display text-2xl sm:text-3xl font-extrabold uppercase tracking-tight text-foreground mb-4">
              {content.heading}
            </h2>
            {content.description && (
              <p className="text-muted-foreground leading-relaxed mb-6">{content.description}</p>
            )}
            {content.bullets?.length > 0 && (
              <ul className="space-y-3 text-sm text-foreground mb-6">
                {content.bullets.map((t, i) => (
                  <li key={i} className="flex items-center gap-2.5">
                    <span className="h-1.5 w-1.5 bg-primary rounded-full shrink-0" /> {t}
                  </li>
                ))}
              </ul>
            )}
            {content.cta_label && (
              <Link to={content.cta_url || "/financing"} className="btn-themed" data-testid="financing-section-cta">
                {content.cta_label}
              </Link>
            )}
          </div>
          {content.show_calculator && <FinancingCalculator defaultPrice={75000} />}
        </div>
      </div>
    </section>
  );
};
